/**
 * File containing the DriverInitiativeResponseComponent class.
 */
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DriverService } from '../../core/services/driver/driver.service';
import { resetUserToken } from '../../shared/utitlity-functions/utility-functions';

@Component({
    standalone: false,
    selector: 'octo-driver-tia-response',
    templateUrl: './driver-tia-response.component.html',
    styleUrls: ['./driver-tia-response.component.scss'],
})

/**
 * Class representing the DriverTIAResponseComponent.
 */
export class DriverTIAResponseComponent implements OnInit {
    token: string = '';
    showError: boolean = false;
    response: string = '';
    email: string = '';
    isVerifying: boolean = true;
    backToActive: string = '';
    success: boolean = false;

    constructor(
        private activeRoute: ActivatedRoute,
        private driverService: DriverService
    ) {
        this.token = this.activeRoute.snapshot.params['token'];
    }

    ngOnInit(): void {
        resetUserToken();
        this.isVerifying = true;
        if (this.token) {
            //  Call the backend to verify the tia and token
            this.driverService.makeTia(this.token).subscribe(
                (response: any) => {
                    this.showError = !response.success;
                    this.response = response?.data?.driver_response;
                    this.email = response?.data?.email;
                    this.backToActive = response?.data?.back_to_active;
                    this.isVerifying = false;
                    this.success = true;
                },
                (error) => {
                    this.showError = true;
                    this.isVerifying = false;
                }
            );
        } else {
            this.showError = true;
            this.isVerifying = false;
        }
    }
}
